import styled from 'styled-components';
import { Button } from '@app/src/common/Button';
import { FONTS, SIZE } from '@app/src/ui';

const MAIN = 'Home/listProducts/ListProducts';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: blocK;
  transition: transform 500ms ease-in-out;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 100vh;
  }
`;

export const ButtonPackage = styled(Button)`
  text-transform: uppercase;
  font-family: ${FONTS.ROBOTO_BOLD};
  width: 120px;
  font-size: 11px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    font-size: 12px;
    width: 160px;
    margin-left: 32px;
  }
`;

ButtonPackage.displayName = `${MAIN}/ButtonPackage`;
